import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import * as LoadingScreen from 'ui-library/LoadingScreen';
import Modal from 'ui-library/modals/Modal';
import {RowSelectionMode} from 'ui-library/scrollable/ScrollableTableConstants';

import ComplexPolymerComponentSearchView from './ComplexPolymerComponentSearchView';

export interface ComplexPolymerComponentSearchModalProps {
  onRequestClose: () => void;
  schemaIds: Array<string>;
  componentTypes: Array<string>;
  complexPolymerTypeDescriptor: string;
  onSubmit: (ids: Array<string>) => Promise<void>;
  titleText: string;
  submitButtonText: string;
  rowSelectionMode: RowSelectionMode;
  isDisabled?: (ids: Array<string>) => boolean;
}

export default function ComplexPolymerComponentSearchModal({
  onRequestClose,
  schemaIds,
  componentTypes,
  complexPolymerTypeDescriptor,
  onSubmit,
  titleText,
  submitButtonText,
  rowSelectionMode,
  isDisabled,
}: ComplexPolymerComponentSearchModalProps): JSX.Element {
  const [selectedIds, setSelectedIds] = useState<Array<string>>([]);

  let disabled = selectedIds.length === 0;
  if (isDisabled) {
    disabled = isDisabled(selectedIds);
  }

  const buttons = [
    {text: 'Cancel', cancel: true},
    {
      text: submitButtonText,
      disabled,
      submit: true,
    },
  ];

  return (
    <Modal
      title={titleText}
      large={true}
      buttons={buttons}
      onRequestClose={onRequestClose}
      fullWidth={true}
      fullHeight={true}
      scrollable={false}
      onRequestSubmit={async () => {
        LoadingScreen.show(`Updating ${complexPolymerTypeDescriptor}...`);

        try {
          await onSubmit(selectedIds);
        } finally {
          onRequestClose();
          LoadingScreen.hide();
        }
      }}
    >
      <div className={css(styles.bodyContainer)}>
        <ComplexPolymerComponentSearchView
          schemaIds={schemaIds}
          setSelectedIds={setSelectedIds}
          componentTypes={componentTypes}
          rowSelectionMode={rowSelectionMode}
        />
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
  },
  bodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
